import { MenuDrawer } from '@/scripts/theme/menu-drawer'
import { TsDOM as q } from '@/scripts/core/TsDOM'
import {
	ATTRIBUTES,
	PUB_SUB_EVENTS,
	SELECTORS,
	subscribe,
	SubscriberCallback,
} from '@/scripts/core/global'
import Accordion from '../optional/accordion'
import { lock, unlock } from 'tua-body-scroll-lock'



export class HeaderDrawer extends MenuDrawer {
	static override htmlSelector = 'header-drawer'
	static override selectors = {
		...MenuDrawer.selectors,
	}
	header?: HTMLElement
	borderOffset?: number;
	menuItems?: NodeListOf<HTMLElement>;
	cartDrawerOpenedUnsubscriber: SubscriberCallback | undefined = undefined

	constructor() {
		super();
		this.menuItems = q.ol('.list-menu__item', this);
		this.events();
	}

	override connectedCallback() {
		this.cartDrawerOpenedUnsubscriber = subscribe(
			PUB_SUB_EVENTS.cartOpened,
			() => {
				const isOpen = this.mainDetails.hasAttribute('open')
				if (isOpen) this.mainSummary.dispatchEvent(new Event('click'))
			}
		)
	}

	override disconnectedCallback() {
		if (this.cartDrawerOpenedUnsubscriber) {
			this.cartDrawerOpenedUnsubscriber(undefined)
		}
	}

	events(): void {
		this.initMenuDropdown();
	}

	override getInstanceSelectors() {
		this.instanceSelectors = HeaderDrawer.selectors
	}

	setHeader() {
		return this.header || q.rs(SELECTORS.sectionHeader)
	}

	setBorderOffset() {
		return this.borderOffset ||
			q.rs(SELECTORS.headerWrapper).dataset.ucHeaderWrapper == 'border-bottom'
			? 1
			: 0
	}

	override openMenuDrawer(summaryElement: HTMLElement) {
		this.header = this.setHeader()
		this.borderOffset = this.setBorderOffset()
		document.documentElement.style.setProperty(
			'--header-bottom-position',
			`${Math.round(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
		)
		this.header.setAttribute('data-uc-header-menu-open', '')

		setTimeout(() => {
			this.mainDetails.setAttribute(ATTRIBUTES.menuOpening, '')
		})

		summaryElement.setAttribute('aria-expanded', 'true')
		window.addEventListener('resize', this.onResize)
		window.TsDOM.trapFocus(this.mainDetails, summaryElement)
		document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
		lock(document.querySelector('.menu-drawer__navigation-container') as HTMLElement, {
			overflowType: 'clip'
		})
	}

	override closeMenuDrawer(
		event: Event | undefined,
		elementToFocus: HTMLElement | undefined = undefined
	) {
		if (!elementToFocus) return
		this.header = this.setHeader()
		super.closeMenuDrawer(event, elementToFocus)
		this.header.removeAttribute('data-uc-header-menu-open')
		window.removeEventListener('resize', this.onResize)
		unlock(document.querySelector('.menu-drawer__navigation-container') as HTMLElement)
	}

	onResize = () => {
		if (!this.header) return
		this.borderOffset = this.setBorderOffset()
		document.documentElement.style.setProperty(
			'--header-bottom-position',
			`${Math.round(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
		)
		document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`)
	}

	initMenuDropdown() {
		new Accordion({
			el: '.menu-drawer__menu > li',
			trigger: '.list-menu__item',
			showOne: true,
			firstOpen: true,
			activeClass: 'is-open'
		})
	}

	
}
